var styles = {"wrapper":"universal-date-input__wrapper_1y2ws","block":"universal-date-input__block_1y2ws","calendarIcon":"universal-date-input__calendarIcon_1y2ws","calendarContainer":"universal-date-input__calendarContainer_1y2ws","blink":"universal-date-input__blink_1y2ws"};
require('./index.css');

export { styles as s };
